import { getComponentElement } from "./baseComponent.helpers";
import { CdpaTimerComponent } from "./cdpaTimer.component";
import { HTMLElementAttribute } from "./misc.enums";
export var CdpaAlertId;
(function (CdpaAlertId) {
    CdpaAlertId["GlobalAlert"] = "global-alert";
    CdpaAlertId["DynamicAlert"] = "dynamic-alert";
})(CdpaAlertId || (CdpaAlertId = {}));
export class CdpaAlertComponent {
    constructor(elementId) {
        this.alertElement = getComponentElement(document.getElementById(elementId));
        this.messageElement = getComponentElement(this.alertElement.querySelector(".cdpa-alert__message"));
    }
    set isHidden(value) {
        if (value) {
            this.alertElement.setAttribute(HTMLElementAttribute.Hidden, "");
        }
        else {
            this.alertElement.removeAttribute(HTMLElementAttribute.Hidden);
        }
    }
    set message(value) {
        this.messageElement.innerHTML = value;
        this.isHidden = !!value;
    }
    addCountdown(duration) {
        const cooldownElement = getComponentElement(this.alertElement.querySelector(".cdpa-alert__cooldown"));
        const timerElement = getComponentElement(this.alertElement.querySelector(".cdpa-alert__timer"));
        if (cooldownElement && timerElement) {
            cooldownElement.removeAttribute(HTMLElementAttribute.Hidden);
            new CdpaTimerComponent(timerElement).startCountdown$(duration).subscribe(() => {
                this.isHidden = true;
            });
        }
    }
}
